import styled from "@emotion/styled";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const StyledLabel = styled.label`
  display: block;
  font-weight: 600;
  margin-right: 4px;
  padding: 2px 0 4px;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
`;

export const FormRow = styled.div`
  display: flex;
  gap: ${withVar(SpacingToken.Spacing3)};
`;

export const StyledSelectedItemWrapper = styled.div`
  line-height: 38px;
  padding: 0 12px;
  height: 38px;
  width: 150px;
`;

export const StyledItemWrapper = styled.div`
  line-height: 38px;
  padding: 0 12px;
  height: 38px;
  width: 150px;

  li.selected &,
  &:hover {
    background-color: ${withVar(DesignToken.ActionPrimaryDefault)};
    color: ${withVar(DesignToken.ContentInvertPrimary)};
  }
`;

export const ItemWrapper = styled.span`
  padding-right: 12px;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-height: 80vh;
`;

export const StyledBarWrapper = styled.div`
  padding: 20px 24px 12px 24px;
`;

export const Body = styled.div`
  padding: 24px;
  overflow: auto;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
`;

export const StyledUnderTableContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AddButton = styled.button`
  padding: 0;
  border: none;
  background-color: transparent;
  box-shadow: none;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
  outline: none;

  &:hover &:not(:disabled) {
    opacity: 0.8;
  }

  &:disabled {
    span.text {
      color: ${withVar(DesignToken.ContentBasicDisabled)};
    }
  }

  span.text {
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: ${withVar(DesignToken.ActionPrimaryDefault)};
  }
`;
